import { useDocTitle } from 'util/hooks'

import React from 'react'

export const Home = () => {
	useDocTitle('All for One - Home')

	return (
		<>
		</>
	)
}
